import React from "react";
import { FC } from "react";
import styled, { StyledComponent } from "styled-components";

export interface Props {
    listId: string;
    entries: string[] | null;
}
  
/* istanbul ignore next */
const Unordered = styled.ul(({theme}) => `
    font-size: ${theme.text.fontSize};
    line-height: ${theme.text.lineHeight};
`);

const Item = styled.li(({theme}) => `
    font-family: ${theme.fontFace};
    color: ${theme.fg?.primary};
`);
  

const UnorderedList: StyledComponent<FC<Props>, object> = styled(({listId, entries}: Props) => (
    <>
        <Unordered id={listId}>
            {entries?.map((entry) => {
                return (
                    <Item key={entry}>{entry}</Item>
                );
            })}
        </Unordered>
    </>
))``;

export default UnorderedList;